export * from './auth';
export * from './cust';
export * from './meas';

export const pathnames = {
  login: '/api/auth/login',
  logout: '/api/auth/logout',
  customers: '/api/cust/customers',
  equipments: '/api/cust/equipments',
  items: '/api/meas/items',
  values: '/api/meas/values',
  valuesCount: '/api/meas/values/count',
  zipValues: '/api/zip/values',
} as const;
